import { makeAuthorizeHttpClientDecorator } from "../decorators/authorize-http-client-decorator-factory";
import { ReportsFilesDatasource } from "data/datasources/reports-files.datasource";

export const makeReportsFilesDatasource = () =>
  new ReportsFilesDatasource(makeAuthorizeHttpClientDecorator());
